import { Vendors } from "../utils/vendor";
import { Peripheral } from "../shared/Peripheral";
import type { ConnectionType } from "../shared/types";
import { PeripheralType } from "../shared/types";
import { ReceiptLanguage, ReceiptLanguages } from "./enums";
import { EscPrinterEncoder, StarPrinterEncoder } from "./encoders";
import { ReceiptPeripheralInfo } from "./types";
export abstract class ReceiptPrinter extends Peripheral {
  abstract print(bytes: Uint8Array): Promise<boolean>;
  abstract popCashDrawer(): Promise<boolean>;

  constructor(connectionType: ConnectionType) {
    super(PeripheralType.receiptPrinter, connectionType);
  }

  get encoder(): EscPrinterEncoder {
    if (
      this.vendorId &&
      Vendors.star.supported[PeripheralType.receiptPrinter].indexOf(
        this.vendorId
      ) !== -1
    ) {
      return new StarPrinterEncoder();
    }
    return new EscPrinterEncoder();
  }

  override get info(): ReceiptPeripheralInfo {
    return {
      ...super.info,
      language: this.language,
    } as ReceiptPeripheralInfo;
  }

  get language(): ReceiptLanguage {
    if (this.vendorId) {
      if (
        Vendors.star.supported[PeripheralType.receiptPrinter].indexOf(
          this.vendorId
        ) !== -1
      ) {
        if (this.productId) {
          // McPrint 30/31L/31LB
          const mcPrint3Id = 71;

          // TSP100
          const tsp100Id = 3;

          const tsp650Id = 1;

          if (this.productId == mcPrint3Id) {
            return ReceiptLanguages.starPrint;
          } else if (this.productId == tsp100Id) {
            return ReceiptLanguages.starGraphic;
          } else if (this.productId == tsp650Id) {
            return ReceiptLanguages.starLine;
          }
        }
      }
    }

    return ReceiptLanguages.esc;
  }
}
